export const MIN_IMAGE_SIZE = 0.3;
export const MAX_IMAGE_SIZE = 2;
export const STEP_IMAGE_SIZE = 0.1;
